<script>
import Topbar from '@/components/shared/dark-topbar'

export default {
  components: {
    Topbar
  },
  data () {
    return {}
  },
  created: () => {
    document.body.setAttribute('data-layout', 'horizontal')
    document.body.setAttribute('data-topbar', 'dark')
  },
  methods: {}
}
</script>

<template>
  <div class="wrapper">
    <Topbar />
    <div class="page-content">
      <slot />
    </div>
    <Footer />
  </div>
</template>
